// FLAGS: none
// The browser entry point named in index.html: runs the boot sequence (interceptors, feature flag, i18n and
// what follows the language — document language, date locale, the miss trace and, when the profile decided,
// the URL rewrite), then mounts the app once inside the Redux store and the router, under the language prefix the
// boot found in the address, if any. Consent is NOT part of
// this sequence — the Cookiebot script is injected from the top of `index.html`'s head, before any of this
// runs. Everything else that precedes App lives in `src/boot/`.
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import boot from "@src/boot/bootstrap";
import { getRouterBasename } from "@src/boot/routerBasename";
import { failBoot } from "@src/boot/bootLoader";
import LazyApp from "@src/boot/LazyApp";
import webVitalsReporter from "@src/appInsights/webVitalsReporter";
import reportWebVitals from "@src/reportWebVitals";
import store from "@src/store";

import "@openup/shared/tailwind.css";

const root = createRoot(document.getElementById("root") as HTMLElement);

const mount = async () => {
  await boot();
  root.render(
    <Provider store={store}>
      <BrowserRouter basename={getRouterBasename()}>
        <LazyApp />
      </BrowserRouter>
    </Provider>,
  );
};

// `boot()` never rejects; this guards the render itself, the one step that has nothing above it.
mount().catch(failBoot);

reportWebVitals(webVitalsReporter);
